import {makeStyles} from "@material-ui/core/styles";

const theme = (props) => {
  const styles = makeStyles(theme => ({
    paper: {
      padding: "20px",
      paddingBottom: "0",
    },
    headerLeftCol: {
      display: 'flex',

      "& svg": {
        marginRight: "15px",
        fontSize: "24px",
      }
    },
    headerRightCol: {
      display: 'flex',
      alignItems: 'end',
      justifyContent: 'flex-end',

      "& span": {
        marginRight: "10px",
      },

      "& svg": {
        marginBottom: "1px",
        fontSize: "22px",
        cursor: "pointer",
      }
    },
    contentContainer: {
      padding: "30px 10px",
      borderRadius: "8px"
    },
    tableTitleSection: {
      display: 'flex',
      alignItems: 'center',
      marginTop: "8px",
      padding: "12px",
    },
    tableTitle: {
      marginRight: "10px",
      fontSize: 16,
      lineHeight: '20px',
      fontWeight: 700,
      color: '#111827',
      fontFamily: 'Helvetica, Arial, sans-serif',
      textTransform: 'none',
    },
    tableSubtitle: {
      margin: 0,
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 500,
      color: '#111827',
      fontFamily: 'Helvetica, Arial, sans-serif',
      textTransform: 'none',
    },
    contentSections: {
      padding: "20px 10px",
      marginBottom: "30px",
    },
    infoPaper: {
      backgroundColor: "#eff6ff",
      border: "1px dashed #bfdbfe",
    },
    infoLeftCol: {
      display: 'flex',

      "& svg": {
        marginRight: "15px",
        fill: "#1e3a8a",
      }
    },
    infoRightCol: {
      display: 'flex',
      alignItems: 'center ',
      justifyContent: 'flex-end',

      "& svg": {
        fontSize: "24px",
        cursor: "pointer",
      }
    },
    infoTitle: {
      margin: 0,
      fontSize: 15,
      lineHeight: '18px',
      fontWeight: 500,
      color: '#1e3a8a',
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.75),
      textTransform: 'none',
    },
    infoText: {
      margin: `${theme.spacing(0.5)}px 0 0 0`,
      fontSize: 12,
      lineHeight: '16px',
      color: '#64748b',
      textTransform: 'none',
    },
    scheduledTable: {
      width: '100%',

      "& th": {
        fontSize: "12px",
        color: "#888",
        fontWeight: 500,
        textAlign: "left",
        padding: "8px 10px",
        borderBottom: "0.5px solid #e8e8e8"
      },

      "& td": {
        fontSize: "13px",
        padding: "10px 10px",
        borderBottom: "0.5px solid #e8e8e8",
        verticalAlign: "middle"
      },
    },
    statusDot: {
      marginTop: "3px",
    },
    successDot: {
      fill: "#16a34a !important"
    },
    errorDot: {
      fill: "#dc2626 !important"
    },
    jobName: {
      margin: 0,
      fontFamily: 'Helvetica, Arial, sans-serif',
      fontSize: 13,
      lineHeight: '16px',
      fontWeight: 700,
      textTransform: 'uppercase',
      color: '#0f172a',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    jobDate: {
      margin: 0,
      fontSize: 12,
      lineHeight: '14px',
      fontFamily: 'Helvetica, Arial, sans-serif',
      color: '#111827',
      textTransform: 'none',
    },
    jobMeta: {
      margin: '2px 0 0 0',
      fontSize: 12,
      lineHeight: '14px',
      color: '#6b7280',
      fontFamily: 'Helvetica, Arial, sans-serif',
      textTransform: 'none',
    },
    scheduledTableHeaderRow: {
      border: '0.5px solid #e5e7eb',
      borderLeftWidth: 3,
      borderRadius: 0,
      padding: theme.spacing(1),
      minWidth: 0,
      [theme.breakpoints.down('md')]: {
        gridTemplateColumns: 'minmax(0, 1fr) auto',
      },
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
        alignItems: 'start',
      },
      "& th:last-child": {
        textAlign: "right !important",
        paddingRight: "23px !important",
      }
    },
    scheduledTableBodyRow: {
      "& td:first-child": {
        display: "flex"
      }
    },
    scheduledTableJobCellText: {
      marginLeft: "10px",
    },
    statusPill: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 999,
      padding: '3px 10px',
      fontSize: 12,
      lineHeight: '14px',
      fontWeight: 500,
      minWidth: 58,
      fontFamily: 'Helvetica, Arial, sans-serif',
      textTransform: 'none',
      justifySelf: 'end',
      [theme.breakpoints.down('sm')]: {
        justifySelf: 'start',
      },
    },
    successPill: {
      color: '#15803d',
      background: '#dcfce7',
    },

    errorPill: {
      color: '#b91c1c',
      background: '#fee2e2',
    },
    tableErrorRow: {
      cursor: "pointer",
    },
    failedJobWrap: {
      borderRight: "1px solid #f5dedf",
      borderLeft: "2px solid #dc2626",
      //borderRadius: "5px",
      padding: "0px !important",
      marginTop: "8px"
    },
    errorEventHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: '1px solid #f5dedf',
    },
    errorEventCopyError: {
      display: 'flex',
      alignItems: 'center',
      cursor: "pointer",

      gap: "6px",
      background: "#ffffff",
      border: "0.5px solid #c8c8c8",
      borderRadius: "8px",
      padding: "6px 12px",
      fontSize: "13px",
      color: "#1a1a1a",

      "& svg": {
        fontSize: "17px",
      }
    },
    errorEventNameSection: {
      display: 'flex',
      alignItems: 'center',

      "& svg": {
        marginRight: "10px",
        fill: "#dc2626"
      }
    },
    errorEventMetaSection: {
      display: 'flex'
    },
    contentRow: {
      display: 'flex',
      alignItems: 'center',
      margin: "20px 0",
    },
    contentRowLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: "10px",
    },
    messageValueWrap: {
      color: "#cc3c68"
    },
    errorStatusText: {
      marginRight: "15px",
      color: "#dc2626"
    },
    failedJobContent: {
      background: "#fcf6f6",
      padding: "16px 12px"
    },
    counterChip: {
      borderRadius: "50%",
      width: "20px",
      height: "20px",
      display: "flex",
      justifyContent: "center",
      fontSize: "14px",
      alignItems: "center",
      marginLeft: "10px",
    },
    errorCounterChip: {
      backgroundColor: "#fcf6f6",
      color: "#dc2626",
    },
    scheduledCounterChip: {
      backgroundColor: "#efeff1",
      color: "#6d768a",
    },
    openRunsPanel: {
      margin: '14px 0 0',
      padding: '12px 4px 0',
      borderTop: '1px solid #bfdbfe',
      maxHeight: 260,
      overflowY: 'auto',
    },

    openRunRow: {
      display: 'flex',
      alignItems: 'center',
      gap: 24,
      padding: '14px 8px',
      borderBottom: '1px solid #dbeafe',
      minHeight: 58,
    },

    openRunIdentity: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      minWidth: 0,
      flex: 1,
    },

    openJobCellText: {
      marginLeft: "10px"
    },

    openRunPulse: {
      borderRadius: '50%',
      fill: '#2563eb !important',
    },

    openRunDuration: {
      flexShrink: 0,
      marginRight: '2%',
      color: '#1e293b',
      fontSize: 12,
      lineHeight: '16px',
      fontWeight: 600,
      whiteSpace: 'nowrap',
    },

    openRunStatus: {
      flexShrink: 0,
      color: '#1e40af',
      backgroundColor: '#dbeafe',
      borderRadius: 999,
      padding: '5px 10px',
      fontSize: 12,
      lineHeight: '14px',
      fontWeight: 700,
      whiteSpace: 'nowrap',
      marginRight: '1%',
    },

    openRunsEmpty: {
      padding: '20px 8px 8px',
      textAlign: 'center',
    },

    openRunsEmptyTitle: {
      color: '#334155',
      fontSize: 13,
      fontWeight: 700,
    },

    openRunsEmptyText: {
      marginTop: 4,
      color: '#64748b',
      fontSize: 12,
    },

    openRunsCount: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 22,
      height: 22,
      marginLeft: 8,
      padding: '0 6px',
      borderRadius: 999,
      backgroundColor: '#dbeafe',
      color: '#1d4ed8',
      fontSize: 12,
      fontWeight: 700,
      verticalAlign: 'middle',
    },

  }));
  return styles();
}
export default theme;

